import { type FC } from 'react';

import { type IconProps } from './types';

export const Card32V4Icon: FC<IconProps> = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5.75C4.61929 5.75 3.5 6.86929 3.5 8.25V8.875H27.5V8.25C27.5 6.86929 26.3807 5.75 25 5.75H6ZM3.5 21.25V12.625H27.5V21.25C27.5 22.6307 26.3807 23.75 25 23.75H6C4.61929 23.75 3.5 22.6307 3.5 21.25ZM1.5 8.25C1.5 5.76472 3.51472 3.75 6 3.75H25C27.4853 3.75 29.5 5.76472 29.5 8.25V21.25C29.5 23.7353 27.4853 25.75 25 25.75H6C3.51472 25.75 1.5 23.7353 1.5 21.25V8.25ZM7.5 15.625C6.46447 15.625 5.625 16.4645 5.625 17.5V18.75C5.625 19.7855 6.46447 20.625 7.5 20.625H10.5C11.5355 20.625 12.375 19.7855 12.375 18.75V17.5C12.375 16.4645 11.5355 15.625 10.5 15.625H7.5Z"
        fill="#00FFBB"
      />
    </svg>
  );
};
